export const userNormalizer = value => value && value.toLowerCase().replace(/[\\/?;<>’'&]/g, '').trim();
export const numberNormalizer = value => value && value.replace(/\D/g, '');
export const phoneNormalizer = value => value && value.replace('+', '').replace('-','');